module.exports = __webpack_public_path__ + "img/banner.9811302e.svg";